// @flow
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Image } from 'components/atoms/image';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  imageUrl: string,
  backgroundImageUrl: string | null,
  thumbnailImage: string,
};

export const VenetianBlinds = (props: Props) => {
  const { backgroundImageUrl, imageUrl, thumbnailImage } = props;
  if (!backgroundImageUrl) {
    return (
      <div
        className={'venetian-blind'}
        style={{ backgroundImage: `url(${imageUrl})` }}
      />
    );
  }

  return (
    <TransitionGroup className={'venetian-blind-container'}>
      <CSSTransition
        key={`${imageUrl}`}
        classNames="venetian-blind"
        timeout={300}
      >
        <div
          className={'venetian-blind'}
          style={{ backgroundImage: `url(${backgroundImageUrl})` }}
        >
          <div className={'foreground-image first'}>
            <img src={imageUrl} alt={'section'} />
          </div>
          <div className={'foreground-image second'}>
            <img src={imageUrl} alt={'section'} />
          </div>
          <div className={'foreground-image third'}>
            <img src={imageUrl} alt={'section'} />
          </div>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};
